<template>
    <tamplate>
        <div class="list list3">
            <catalog-items-grid :items="items"></catalog-items-grid>
        </div>
        <div v-if="nextUrl" class="list-more mt-4">
            <button @click="getItems()" type="button" class="btn btn-outline-regular btn-bi w-100">
                <ins>Показать еще</ins>
            </button>
        </div>
    </tamplate>
</template>

<script>
export default {
    props: ["id", "url", "view"],

    data: function () {
        return {
            items: [],
            nextUrl: this.url,
        };
    },
    methods: {
        getItems() {
            axios.get(this.nextUrl).then(({data}) => {
                this.items =[
                    ...this.items,
                    ...data.paginator.data
                ];

                this.nextUrl = data.url;
            }).catch((err) => {
                console.error(err);
            });
        },
    },
    computed: {
        isAuth() {
            return this.$store.state.isAuth;
        },

        email() {
            return this.$store.state.email;
        },
    },
};
</script>
